"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarGroupOverlay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const avatar_group_overlay_style_1 = __importDefault(require("./avatar.group.overlay.style"));
const avatar_group_svg_1 = __importDefault(require("./avatar.group.svg"));
const constants_1 = require("./constants");
class AvatarGroupOverlay extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, clipPathId, icon } = this.props;
            return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root }, { children: [jsx_runtime_1.jsx(avatar_group_svg_1.default, Object.assign({ viewBox: constants_1.AVATAR_GROUP_VIEWBOX_SIZE, className: classes.overlay }, { children: jsx_runtime_1.jsx("rect", { width: "100", height: "100", clipPath: `url(#${clipPathId})` }, void 0) }), void 0),
                    jsx_runtime_1.jsx("div", Object.assign({ className: classes.icon }, { children: icon }), void 0)] }), void 0));
        };
    }
}
exports.AvatarGroupOverlay = AvatarGroupOverlay;
AvatarGroupOverlay.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    clipPathId: prop_types_1.default.string.isRequired,
    icon: prop_types_1.default.node.isRequired
};
exports.default = react_jss_1.default(avatar_group_overlay_style_1.default)(AvatarGroupOverlay);
//# sourceMappingURL=avatar.group.overlay.js.map